import React from 'react';
import { useConstructorStore } from '../store/constructorStore';
import { t } from '../i18n';

export const Step3Items: React.FC = () => {
  const { items, language, addItem, removeItem, updateItem } = useConstructorStore();

  const inputStyle: React.CSSProperties = {
    width: '100%', padding: '10px 12px', border: '1px solid #ddd',
    borderRadius: 8, fontSize: 15, outline: 'none',
  };

  const cardStyle: React.CSSProperties = {
    background: '#f8f9fa', borderRadius: 12, padding: 16, marginBottom: 12,
    border: '1px solid #eee',
  };

  return (
    <div>
      <h2 style={{ fontSize: 20, fontWeight: 700, marginBottom: 20 }}>{t('step3_title', language)}</h2>

      {items.map((item, index) => (
        <div key={index} style={cardStyle}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
            <span style={{ fontSize: 14, fontWeight: 600, color: '#666' }}>
              📦 {t('item_name', language)} #{index + 1}
            </span>
            {items.length > 1 && (
              <button onClick={() => removeItem(index)} style={{
                background: '#fee', border: 'none', borderRadius: 6,
                padding: '4px 10px', color: '#c00', cursor: 'pointer', fontSize: 13,
              }}>
                {t('delete', language)}
              </button>
            )}
          </div>

          <div style={{ marginBottom: 10 }}>
            <input style={inputStyle} value={item.name}
              onChange={(e) => updateItem(index, 'name', e.target.value)}
              placeholder={t('item_name_placeholder', language)} />
          </div>

          <div style={{ marginBottom: 10 }}>
            <input style={inputStyle} value={item.price}
              onChange={(e) => updateItem(index, 'price', e.target.value)}
              placeholder={t('item_price_placeholder', language)} />
          </div>

          <div>
            <input style={inputStyle} value={item.description || ''}
              onChange={(e) => updateItem(index, 'description', e.target.value)}
              placeholder={t('item_description', language)} />
          </div>
        </div>
      ))}

      <button onClick={addItem} style={{
        width: '100%', padding: 14, border: '2px dashed #ddd', borderRadius: 12,
        background: 'transparent', fontSize: 15, color: '#666', cursor: 'pointer',
        fontWeight: 600,
      }}>
        {t('add_item', language)}
      </button>
    </div>
  );
};
